var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.41 64.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: #838484;\n      }\n\n      @keyframes loading {\n        0% {\n          transform: rotate(0deg) scale(.9);\n        }\n        100% {\n          transform: rotate(360deg) scale(.9);\n        }\n      }\n\n      .loading {\n        animation: loading 3s infinite linear;\n        transform-origin: center;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 61.13,
    y1: 11.43,
    x2: 22.86,
    y2: 6.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3758a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3b5daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#324c91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#25326b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20295d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#222e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2a3d7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#36549e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3b5daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#27499e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#27499e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5171b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6383c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6a89c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7e9ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#86a1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192352"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.41,
    y1: 7.07,
    x2: 5.96,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#64bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#67bb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#69bc45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5bb947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#62ba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#72be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#77bf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77bf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6dbd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7ec14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#86c452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3aad49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.23,
    y1: 31.95,
    x2: 7.91,
    y2: 42.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#d9b043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e7c15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#edc868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#dbb552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cfa944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d4b04b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e3c661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ecd26d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f6ee88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f6ee88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eeda71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e8ca60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#debe55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8b74f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac842e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.6,
    y1: 50.54,
    x2: 33.1,
    y2: 57.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 39.58,
    y1: 57.39,
    x2: 51.45,
    y2: 41.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#64bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#67bb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#69bc45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5bb947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#62ba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#72be44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#77bf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77bf43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6dbd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7ec14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#86c452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3aad49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 56.59,
    y1: 32.86,
    x2: 47.81,
    y2: 21.13,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    className: "loading"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,15.05L29.61.37c-.43-.24-.92-.37-1.41-.37h0l-10.71,13.58,8.81-1.28c1.22-.18,2.51-.18,3.79,0l25.94,3.73h0c-.31-.43-.61-.73-1.04-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.8.37L1.41,15.05c-.43.24-.8.61-1.04,1.04H.37l6.36,16.09,3.3-8.32c.49-1.16,1.1-2.26,1.9-3.3L28.2,0h0c-.49.06-.98.18-1.41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.5,50.72L.41,48.21h-.04c-.25-.43-.37-.92-.37-1.41v-29.36c0-.43.12-.92.37-1.35l9.72,24.29c.49,1.23,1.1,2.32,1.9,3.31l4.11,5.25,1.34,1.71.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.91,50.65l-10.71,13.58c-.49,0-.98-.12-1.41-.37L1.41,49.18c-.41-.23-.76-.52-1-.97-.01-.02-.03-.04-.04-.07l17.07,2.5,8.87,1.3c1.28.19,2.51.19,3.79,0l8.81-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.25,40.38c-.49,1.16-1.1,2.26-1.9,3.3l-16.27,20.55h0c.61,0,1.1-.12,1.47-.37l25.39-14.68c.43-.24.8-.61,1.04-1.04h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.55,63.9l25.39-14.68c.43-.24.8-.61,1.04-1.04h0l-6.36-16.15-3.36,8.39c-.49,1.16-1.1,2.26-1.9,3.3l-16.27,20.55h0c.61,0,1.1-.12,1.47-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.41,46.8v-29.36c0-.49-.12-.98-.37-1.41h0l-17.13-2.45,5.57,6.97c.8.98,1.41,2.08,1.9,3.3l9.67,24.35h0c.18-.43.31-.92.37-1.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyLogo);
export default __webpack_public_path__ + "static/media/only_logo.8a4650e14c2f7aee5ce25fe564a20cad.svg";
export { ForwardRef as ReactComponent };